import React, { useEffect, useRef, useState } from "react";
import { DOCTOR_DETAIL_IAMGE, PROFILE_IMG } from "../../utils/aap-image-constant";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { useTranslation } from "react-i18next";
import { getAllMatching } from "../../hooks/services/api-services";
import { useSelector } from "react-redux";
import { decryptAEStoJSON, EllipsisWithTooltip } from "../../utils/utilities";
import { DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { debounce } from "lodash";
import Input from "../../components/common/input";
import TextArea from "../../components/common/text-area";
import Modal from "../../components/common/Model";
import BreadCrum from "../../components/common/BreadCrum";
import { API_URL } from "../../utils/url-constants";
import i18n from "../../i18n";

const MatchingList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const CareerId = location?.state?.CareerId;
  const ViewMatchingmodal = useRef();
  const isFirstRender = useRef(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const payload = {
    pageIndex: searchTerm === "" ? page || 0 : 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    searchText: searchTerm,
    country: CareerId?.country,
    specialization: CareerId?.specialty,
    consultaionType: "",
    minFees: "",
    maxFees: "",
    minExperience: CareerId?.experience,
    maxExperience: CareerId?.experience,
    rating: "",
    language: '',
    clinicId: userData?.id,
    profile: CareerId?.profile,
    languageType:i18n.language,
    contractType: CareerId?.contractType,
    availableFromDate: CareerId?.durationFromDate,
    availableToDate: CareerId?.durationToDate,
    lookingFor: CareerId?.lookingFor,
    city: CareerId?.city,
    availabilityPeriod: [].concat(CareerId?.availabilityPeriod || []),
  slotType:CareerId?.slotType ,
  availabilityType:CareerId?.availabilityType,
  };

  const [rowData, setRowData] = useState([]);

  const fetchgetMatchingData = async () => {
    setPending(true);
    try {
      const response = await getAllMatching(payload);
      if (response?.data?.status !== 200) {
        if (isFirstRender.current) {
        }
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.doctorResponseList);
        setTotalRows(response?.data?.data?.totalElement);
      }
    } catch (err) {
      if (isFirstRender.current) {
      }
    } finally {
      setPending(false);
      isFirstRender.current = false;
    }
  };

  const debouncedFetchData = debounce(fetchgetMatchingData, 500); // 500ms

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel(); // Cleanup function
  }, [page, pageSize, searchTerm, sortColumn, sortDirection, i18n.language]);

  const [viewData, setViewData] = useState({});
  const addButtonClickModal = (data) => {
    setViewData(data);

    ViewMatchingmodal.current.click();
  };
  // Table Columns
  const tableColumnsdoctormatching = [
    {
      name: t("S.No"),
      width: "100px",
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },

    {
      code: "firstName",
      name: t("Doctor Name"),
      width: "170px",
      sortable: true,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fs-12 fw-600">
          <div
            className="rounded-circle overflow-hidden rounded-circle"
          >
            <img
              src={row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG}
              alt=""
              style={{
                objectFit: "cover", objectPosition: "center", width: "32px",
                height: "32px",
              }}

            />
          </div>
          {`${row?.firstName}  ${row?.lastName}`}
        </div>
      ),
    },

    {
      name: t("Specilization"),
      width: "170px",
      sortable: false,
      selector: (row) => row?.specialization,
    },
    {
      name: t("Mobile Number"),
      width: "170px",
      sortable: false,
      selector: (row) => <> {`${row.code} ${row.mobileNo}`}</>,
    },

     {
      code: "availabilityPeriod",
      name: (
        <div
          className="column-header"
          title={t("availabilityPeriod")}
        >
          {t("Availability Period")}
        </div>
      ),
      width: "200px",
      sortable: true,

      selector: (row) => row?.availabilityPeriod,
    },
     {
      code: "slotType",
      name: (
        <div
          className="column-header"
          title={t("slotType")}
        >
          {t("Slot Type")}
        </div>
      ),
      width: "150px",
      sortable: true,

      selector: (row) => row?.slotType,
    },
     {
      code: "availabilityType",
      name: (
        <div
          className="column-header"
          title={t("availabilityType")}
        >
          {t("Availability Type")}
        </div>
      ),
      width: "180px",
      sortable: true,

      selector: (row) => row?.availabilityType,
    },
    {
      name: t("Profile"),
      width: "130px",
      selector: (row) => row.profile,
    },
    {
      name: t("contractType"),
      width: "170px",
      sortable: false,
      selector: (row) => row?.contractType,
    },
    {
      name: t("Job Type"),
      width: "170px",
      sortable: false,
      selector: (row) => row?.lookingFor,
    },

    {
      code: "email",
      name: t("Email"),
      sortable: true,
      selector: (row) => (
        <EllipsisWithTooltip text={`${row.email || "N/A"}`} maxWidth="250px" />

      )
    },
    {
      name: t("Country"),
      sortable: false,
      selector: (row) => row?.country,
    },

    {
      name: t("Address"),
      selector: (row) => (
        <EllipsisWithTooltip text={`${row.address || "N/A"}`} maxWidth="250px" />

      )
    },

    {
      name: t("Detail"),
      selector: (row) => row?.detail,
      cell: (row) => (
        <div className="">
          <button className="border-0 bg-white">
            <button
              className="border-0 bg-white"
              onClick={() => addButtonClickModal(row)}
            >
              <img
                src={DOCTOR_DETAIL_IAMGE}
                alt="View"
                className="editicon ms-2"
              />
            </button>
          </button>
        </div>
      ),
    },
  ];

  const handleBack = () => {
    navigate(ROUTES.JOBPOTSLIST);
  };


   // permission code for this module start
    const [permissionAccess, setPermissionAccess] = useState();
    const rawPermission = useSelector((state) => state?.permission?.value);
    const permissions = decryptAEStoJSON(rawPermission);
  
    useEffect(() => {
      const RoleAccessFilterData =
        permissions &&
        permissions?.filter((v) => v?.moduleName === "Matching Management");
      setPermissionAccess(RoleAccessFilterData?.[0]);
    }, []);
  return (
    <>
      <>
        <div className="main_datatable my-lg-3 my-2">
          <BreadCrum
            firstData={t("My Requiremnet List")}
            iconshow1={true}
            secondData={t("My Matching List")}
            onFirstDataClick={handleBack}
          />

          <TableHeading
            searchValue={searchTerm}
            setSearchValue={setSearchTerm}
            data="Requirement"
            showbutton={false}
          />
          <div className="table-wrapper">
            <TableLayout
              _tblColumns={tableColumnsdoctormatching}
              _rowData={rowData}
              pending={pending}
              pagination={true}
              selectableRows={false}
              setPending={setPending}
              _totalRows={totalRows}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              setSortColumn={setSortColumn}
              setSortDirection={setSortDirection}
            />
          </div>

          <Modal
            modalId="matichingDetails"
            closebtnclass="closebtnclass"
            modalClick={ViewMatchingmodal}
            modalContentClass="add_doctor card px-3 py-0 border border-radius_input"
            className="modal-lg"
          >
            <div className="">
              <div className="row text-start">
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={`${viewData?.firstName || ""} ${viewData?.lastName || ""
                      }`}
                    name="firstName"
                    labelName="Doctor Name"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={viewData?.specialization || ""}
                    name="specialty"
                    labelName="Specialization"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={viewData?.email}
                    name="email"
                    labelName="Email"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={`${viewData?.code || ""} ${viewData?.mobileNo || ""
                      }`}
                    name="mobileNo"
                    labelName="Mobile Number"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={viewData?.country || ""}
                    name="country"
                    labelName="Country"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <Input
                    type="text"
                    value={viewData?.profile || ""}
                    name="profile"
                    labelName="Profile"
                    disabled={true}
                    showAsterisk={false}
                  />
                </div>
                {viewData?.address && (
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.address || ""}
                      name="address"
                      labelName={t("Area / Location of Hospital")}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                )}
                {viewData?.experience && (
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.experience || ""}
                      name="experience"
                      labelName="Experience"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                )}
                {viewData?.description && (
                  <div className="col-md-12 mb-2">
                    <TextArea
                      labelName={t("Brief Description")}
                      name="description"
                      value={viewData?.description || ""}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </div>
      </>
    </>
  );
};

export default MatchingList;
